<template>
  <li>
    <router-link
      :to="categoryLink(category)"
      class="category"
      @click.prevent.stop="$emit('clicked-result', category, 'Category')"
    >
      <div
        class="topic-title"
        v-html="category.name"
      />
      <icon name="arrow" />
    </router-link>
    <div class="subcategories">
      <router-link
        v-for="subcategory in category.descendantCategories"
        :key="subcategory.id"
        :to="categoryLink(subcategory)"
        class="subcategory"
        @click.prevent.stop="$emit('clicked-result', subcategory, 'Category')"
      >
        <div class="topic-title">
          {{ subcategory.name }}
        </div>
        <icon
          name="arrow"
          variant="cccccc"
        />
      </router-link>
    </div>
  </li>
</template>

<script>
import Icon from '@components/singletons/icon';

export default {
  components: { Icon },
  props: {
    category: {
      type: Object,
    },
  },
  emits: ['clicked-result'],
  methods: {
    categoryLink(category) {
      if (category) {
        const route = { name: 'topics#index', params: { categoryId: category.id } };
        const navigationItemsList = this.$store.getters['navigationItems/navigationItemsList'];
        const navItem = navigationItemsList.find(elm => elm.resourceId == category.categoryTypeId);
        if (navItem) {
          route.query = {
            nav: navItem.query,
          };
        }
        return route;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
li {
  margin-bottom: rem-calc(36);
  padding: rem-calc(16);

  @include breakpoint(small) {
    margin-bottom: rem-calc(24);
  }

  a {
    align-items: center;
    color: #333333;
    display: flex;
    margin-right: rem-calc(42);

    .topic-title {
      border-bottom: 1px solid transparent;
      color: black;
      display: inline-block;
      font-weight: $semi-bold;
      margin-bottom: 0;
      font-size: rem-calc(20);
      &:hover {
        border-color: black;
      }
    }

    p {
      display: -webkit-box;
      font-size: rem-calc(14);
      height: rem-calc(32);
      margin: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }

    img {
      height: rem-calc(10);
      width: rem-calc(10);
      padding-left: 12px;
      flex-shrink: 0;
    }
  }

  .subcategories {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: rem-calc(10);
    margin-left: rem-calc(30);
    padding: 0;
    max-width: rem-calc(600);

    .subcategory {
      width: 39%;
      margin: rem-calc(5) 0;
      display: flex;
      align-items: center;

      @include breakpoint(small) {
        width: 100%;
      }

      .topic-title {
        font-size: rem-calc(16);
        font-weight: $normal;
        margin-bottom: 0;
      }

      img {
        height: rem-calc(10);
        width: rem-calc(10);
        padding-left: rem-calc(12);
      }
    }
  }
}
</style>
